import { render } from "./BoqQuotationReadOnly.vue?vue&type=template&id=5d0cc778&scoped=true"
import script from "./BoqQuotationReadOnly.vue?vue&type=script&lang=js"
export * from "./BoqQuotationReadOnly.vue?vue&type=script&lang=js"

import "./BoqQuotationReadOnly.vue?vue&type=style&index=0&id=5d0cc778&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0cc778"]])

export default __exports__